export interface IDirectiveLoadStatus {
  accountDirectiveLoaded: boolean;
  transactionDirectiveLoaded: boolean;
  invoiceDirectiveLoaded: boolean;
  qaDirectiveLoaded: boolean;
  issueDirectiveLoaded: boolean;
  productionDirectiveLoaded: boolean;
}

export class DirectiveLoadStatus implements IDirectiveLoadStatus {
  accountDirectiveLoaded: boolean;
  transactionDirectiveLoaded: boolean;
  invoiceDirectiveLoaded: boolean;
  qaDirectiveLoaded: boolean;
  issueDirectiveLoaded: boolean;
  productionDirectiveLoaded: boolean;
}
